import { useCallback, useEffect } from 'react';
export const useKeybindControlMenu = ({ onOpenDeviceSettings, replace, transfer, deleteDevice, addDevice, addGroup, show_settings_button, user_id, account_id, can_take_changes_groups, }) => {
    const keyupHandler = useCallback((e) => {
        if (e.target instanceof HTMLInputElement ||
            e.target instanceof HTMLTextAreaElement)
            return;
        if (e.shiftKey)
            return;
        switch (e.code) {
            case 'KeyS':
                onOpenDeviceSettings(e);
                break;
            // case 'KeyC':
            //     replace();
            //     break;
            case 'KeyT':
                transfer();
                break;
            // case 'KeyR':
            //     deleteDevice();
            //     break;
            case 'KeyN':
                addDevice();
                break;
            case 'KeyG':
                addGroup();
                break;
            default:
        }
    }, [show_settings_button, user_id, account_id, can_take_changes_groups]);
    useEffect(() => {
        document.addEventListener('keyup', keyupHandler);
        return () => {
            document.removeEventListener('keyup', keyupHandler);
        };
    }, [keyupHandler]);
};
